import React from "react";
import { Button } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import ReactExport from "react-export-excel";
import moment from "moment";

import displayName from "../../helpers/displayName";
import displayDuration from "../../helpers/displayDuration";

const useStyles = makeStyles((theme) => ({
  exportButton: {
    verticalAlign: "bottom",
    marginLeft: "10px",
    marginBottom: "10px",
  },
}));

function ExportRiders(props) {
  const classes = useStyles();

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

  const rData = [];
  let total = 0;

  if (props.data !== null) {
    Object.keys(props.data).forEach((key) => {
      const row = props.data[key];
      total += row.total;
      rData.push({
        date: moment(row.delivery_date).format("YYYY-MM-DD"),
        orderid: row.order_id,
        name: displayName(row.rider?.firstName, row.rider?.lastName),
        email: row.rider?.email,
        mobile: row.rider?.mobileNumber,
        store: displayName(row.store?.firstName, row.store?.lastName),
        total: displayDuration(row.total),
      });
    });

    rData.push({
      date: "TOTAL",
      total: displayDuration(total),
    });
  }

  return (
    <ExcelFile
      element={
        <Button
          variant="contained"
          className={classes.exportButton}
          disabled={props.disabled || false}
        >
          Export
        </Button>
      }
      filename={props.filename}
    >
      <ExcelSheet data={rData} name="Riders">
        <ExcelColumn label="Date" value="date" />
        <ExcelColumn label="Order ID" value="orderid" />
        <ExcelColumn label="Name" value="name" />
        <ExcelColumn label="Email" value="email" />
        <ExcelColumn label="Mobile" value="mobile" />
        <ExcelColumn label="Store" value="store" />
        <ExcelColumn label="Total" value="total" />
      </ExcelSheet>
    </ExcelFile>
  );
}

export default ExportRiders;
